"use client";
import { Button, cn, Typography } from "@kyan/ui";
import { useEffect } from "react";

import { perpRfqSizes } from "#/config/orders";
import { useValidatePerpSize } from "#/hooks/useValidatePerpSize";
import { useMarket } from "#/store/app/portfolio/market";
import { usePerpSize } from "#/store/perps/tradePanel/perpSize";
import { usePerpUnit } from "#/store/perps/tradePanel/perpUnit";
import { formatCompact } from "#/utils/valueFormatters";

import { FocusableSizeInput } from "../../../../../FocusableSizeInput/FocusableSizeInput";

export const PerpRFQ: React.FC = () => {
  const { market } = useMarket();
  const { perpSize, perpSizeInputValue, setPerpSizeInputValue } = usePerpSize();
  const { isUnderlyingSelected, setPerpUnit } = usePerpUnit();

  const sizes = perpRfqSizes[market.underlying];

  const { sizeError, minSize } = useValidatePerpSize({ isRfq: true });

  const handleUpdatePerpSize = (size: string | number | undefined) => {
    setPerpSizeInputValue(String(size));
  };

  useEffect(() => {
    if (!isUnderlyingSelected) return;

    setPerpUnit("USD");
  }, [isUnderlyingSelected, setPerpUnit]);

  return (
    <div className="mb-1 grid gap-2">
      <div className="flex gap-1">
        {sizes.map((item) => (
          <Button
            size="sm"
            key={item}
            variant="alternative"
            className={cn("w-full", {
              "border-primary border": String(item) === perpSize,
            })}
            onClick={() => {
              handleUpdatePerpSize(item);
            }}
          >
            {formatCompact(item)}
          </Button>
        ))}
      </div>

      <FocusableSizeInput
        inputProps={{
          label: "$ Size",
          rightIcon: "USD",
          value: perpSizeInputValue,
          placeholder: "$0",
          error: sizeError,
          autoNumericOptions: {
            currencySymbol: "$",
            decimalPlaces: 0,
          },
          onChange: handleUpdatePerpSize,
        }}
      />

      <div className="flex gap-2">
        <Typography xs grotesk>
          Min size for RFQ:
        </Typography>
        <Typography xs grotesk primary>
          {`$${formatCompact(minSize)}`}
        </Typography>
      </div>
    </div>
  );
};
